module.exports = require("@m4b-design/config-provider");